import metadata from "./seoMetadata.json";

export const AUCTIONS_META_DESCRIPTION = metadata.auctionsDescription;